import type { ColumnConfig } from '@/components/datatable/dataTableTypes';

export const columns: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'issuerLegalName' },
  { field: 'issueDate', type: 'date' },
  { field: 'periodStart', type: 'date' },
  { field: 'periodEnd', type: 'date' },
  { field: 'vatRate', type: 'number', hideInitial: true },
  { field: 'ticketId', type: 'string', template: 'relatedTicket', hideInitial: true },
  { field: 'pointOfSaleName', type: 'string', truncateLength: 32, clusterable: true },
  { field: 'contractName', type: 'string', truncateLength: 32, clusterable: true },
  { field: 'contractId', type: 'string', truncateLength: 8, clusterable: true, hideInitial: true },
];
